/* eslint-disable */
const FETCH_DIGITAL_STORE = "FETCH_DIGITAL_STORE";

const initialState = {};

export const fetchDigitalStore = (payload) => ({
  type: FETCH_DIGITAL_STORE,
  payload,
});

const digitalStoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DIGITAL_STORE:
      return action.payload;
    default:
      return state;
  }
};

export default digitalStoreReducer;
